import { FC,memo } from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { NotTreatedData } from "src/pages/actionDashboard/types";
import ManufacturerNextStepActions from "../manufactureNextStepActions";

type Props = {
  row: NotTreatedData;
  refreshListing: () => void;
};

const PendingTableRow: FC<Props> = ({ row,refreshListing}) => {
  return (
    <tr>
      <td className="text-center align-middle">
        {row.patient_name !== "Redacted" ? (
          <Link to={`/global_patients/${row.patient_id}`}>
            {row.patient_name}
          </Link>
        ) : (
          row.patient_name
        )}
      </td>
       <td className="text-center align-middle">
      <Link 
        to={`/global_patients/${row.patient_id}`}
        className={`${row.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
      >
        {row.patient_id}
      </Link>
    </td>
      <td className="text-center align-middle">
        <Link 
          to={`/cases/detail/${row.bi_case_id}`}
          className={`${row.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
        >
          {row.bi_case_id}
        </Link>
      </td>
       <td className="text-center align-middle">
        {row.drug_name}
      </td>
      <td className="text-center align-middle">
        {row.bi_submitted && format(row.bi_submitted, "MM/dd/yyyy")}
      </td>
      <td className="text-center align-middle">
        {row.bi_completed && format(row.bi_completed, "MM/dd/yyyy")}
      </td>
      <td className="text-center align-middle">{ row.payer}</td>
      <td className="text-center align-middle">{row.provider}</td>

      {/* Medical Coverage */}
      <td className="align-middle">
          <span className={`badge background-color-${row.medical_coverage_status_color}`}>
              {row.medical_coverage_status}
          </span>
      </td>
      {/* <td className="text-center align-middle">
      <ManufacturerNextStepActions refreshListing={refreshListing} kase={row} next_steps={row.next_steps}/>
      </td> */}

      {/* Pharmacy Coverage */}
      <td className="align-middle">
          <span className={`badge background-color-${row.pharmacy_coverage_status_color}`}>
              {row.pharmacy_coverage_status}
          </span>
      </td>
      {/* <td className="align-middle">
          {row.copay_status}
      </td> */}
      <td className="text-center align-middle">
      <ManufacturerNextStepActions refreshListing={refreshListing} kase={row} next_steps={row.next_steps}/>
      </td>
    </tr>
  );
};

export default memo(PendingTableRow);
